import { axiosPath } from "@/axios-path.js";

export default {
  namespaced: true,
  state: {
    transfer_zone_list: []
  },
  mutations: {
    resetState(state) {
      state.transfer_zone_list = [];
    },
    getData(state, data) {
      state.transfer_zone_list = data;
    },
    addTransferZoneList(state, data) {
      state.transfer_zone_list.push(data);
    }
  },
  actions: {
    async deleteTransferZone({ commit, rootState, dispatch }, ID) {
      let url = rootState.api_urls.fetchFoodZoneBack_deleteTransferZone + ID;
      let res = await dispatch("fetchGeneral/axiosPathDeleteData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return res;
      }
    },
    async editTransferZoneList({ commit, rootState, dispatch }, form) {
      let url =
        rootState.api_urls.fetchFoodZoneBack_editTransferZoneList +
        form.transport_zone_id;

      let res = await dispatch(
        "fetchGeneral/axiosPathPutData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return 3;
      } else {
        dispatch("getTransferZoneList");
        return 2;
      }
    },
    async getTransferZoneDetail(
      { commit, rootState, dispatch },
      transport_zone_id
    ) {
      let url =
        rootState.api_urls.fetchFoodZoneBack_getTransferZoneDetail +
        transport_zone_id;

      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        return res;
      }
    },
    async addTransferZoneList({ commit, state, rootState, dispatch }, form) {
      let url = rootState.api_urls.fetchFoodZoneBack_addTransferZoneList;
      let res = await dispatch(
        "fetchGeneral/axiosPathPostData",
        { url, form },
        { root: true }
      );
      if (typeof res == "boolean" && res == false) {
        return false;
      } else {
        commit("addTransferZoneList", res);
        dispatch("getTransferZoneList");
        return true;
      }
    },
    async getTransferZoneList({ commit, state, rootState, dispatch }) {
      let url = rootState.api_urls.fetchFoodZoneBack_getTransferZoneList;
      let res = await dispatch("fetchGeneral/axiosPathGetData", url, {
        root: true
      });
      if (typeof res == "boolean" && res == false) {
        return res;
      } else {
        commit("getData", res);
        return res;
      }
    }
  }
};
